import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'tickets',
    pathMatch: 'full',
  },
  {
    path: 'tickets',
    loadComponent: () => import("./components/tickets-list/tickets-list.component").then(c => c.TicketsListComponent),
  },
  {
    path: '**',
    redirectTo: 'tickets'
  }
];
